var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBitbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-bitbucket_svg__a",
    x1: "97.552%",
    x2: "46.979%",
    y1: "36.569%",
    y2: "65.837%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.552 4.27A.537.537 0 0 0 4 4.81c0 .025 0 .064.013.09L6.31 18.836c.064.347.36.616.719.616H18.04c.27 0 .5-.192.539-.449l2.297-14.092a.53.53 0 0 0-.45-.616c-.025 0-.063-.013-.089-.013L4.552 4.271Zm9.664 10.075h-3.517l-.95-4.98h5.327l-.86 4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-bitbucket_svg__a)",
    d: "M16.145 5.095h-5.07l-.846 4.98h-3.53l-4.158 4.928c.129.116.295.18.475.18h11.025c.27 0 .5-.193.539-.45l1.565-9.638Z",
    transform: "translate(4 4.27)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBitbucket);
export default __webpack_public_path__ + "static/media/login-bitbucket.05ab56f737ce2aa623158d75e988c5dc.svg";
export { ForwardRef as ReactComponent };